function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enterpriseDaily, getEnterpriseEdit, dailyReply, dailydel, getDailyEdit, getCompleted } from '@/api/enterprise';
import file from '@/utils/file';
import uploadFile from '@/components/user/uploads-file';
import { dailyReportMemberApi } from '@/api/business';
import { scheduleStatusApi } from '@/api/user';
import Vue from 'vue';
Vue.use(file);
export default {
  props: {
    editData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editId: {
      type: [String, Number],
      default: ''
    },
    dailyId: {
      type: [String, Number],
      default: 1
    },
    needList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    finishList: {
      type: String,
      default: ''
    }
  },
  watch: {
    finishList: {
      handler: function handler(newVal, oldVal) {
        var data = [];
        data = [this.ruleForm.finish, this.checkedList];
        this.ruleForm.finish = data.map(function (item, index) {
          if (index === data.length - 1) {
            return item;
          } else {
            return item + '\n';
          }
        }).join('');
        this.ruleForm.finish = this.ruleForm.finish.replace(/\n+/g, '\n');
        this.ruleForm.finish = this.ruleForm.finish.replace(/^\n/, '');
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  data: function data() {
    var _this = this;
    var checkFinish = function checkFinish(rule, value, callback) {
      if (!value && _this.dailyId === 1) {
        return callback(new Error(_this.$t('user.work.title')));
      } else if (!value && _this.dailyId === 2) {
        return callback(new Error('请填写本周工作'));
      } else if (!value && _this.dailyId === 3) {
        return callback(new Error('请填写本月工作'));
      } else {
        callback();
      }
    };
    var checkPlan = function checkPlan(rule, value, callback) {
      if (!value && _this.dailyId === 1) {
        return callback(new Error(_this.$t('user.work.tilte1')));
      } else if (!value && _this.dailyId === 2) {
        return callback(new Error('请填写下周计划'));
      } else if (!value && _this.dailyId === 3) {
        return callback(new Error('请填写下月计划'));
      } else {
        callback();
      }
    };
    return {
      drawer: false,
      examineData: [],
      // 参与人
      ruleForm: {
        finish: [],
        plan: [],
        mark: '',
        attach_ids: '',
        types: 0
      },
      rules: {
        finish: [{
          required: true,
          validator: checkFinish,
          trigger: 'blur'
        }],
        plan: [{
          required: true,
          validator: checkPlan,
          trigger: 'blur'
        }]
      },
      reply: {
        content: '',
        daily_id: '',
        pid: 0
      },
      uploadData: {},
      isShow: false,
      replyList: [],
      uid: this.$store.state.user.userInfo.uid,
      avatar: this.$store.state.user.userInfo.avatar,
      id: 0,
      ids: [],
      rollHeight: '',
      editType: false,
      // 是否可以编辑
      textPla: this.$t('user.work.title2'),
      types: -1,
      minHeight: 420,
      fileList: [],
      uploadSize: 2,
      loading: false,
      report_show: false,
      result: [],
      attachList: [],
      saveLoading: false,
      newTitle: '',
      checked: false,
      fileParams: {
        relation_type: 'daily',
        relation_id: 0,
        way: 3,
        eid: 0
      },
      checkedList: ''
    };
  },
  computed: {
    disabled: function disabled() {
      var status = !!this.editId;
      return status && this.editType;
    },
    title: function title() {
      var title = this.$t('user.work.writedaily');
      if (!!this.editId && !this.editType) {
        title = this.$t('user.work.editdaily');
      } else if (!this.editId) {
        if (this.dailyId === 1) {
          title = this.$t('user.work.writedaily');
        } else if (this.dailyId === 2) {
          title = this.$t('user.work.writedailyweek');
        } else if (this.dailyId === 3) {
          title = this.$t('user.work.writedailymonth');
        } else if (this.dailyId === 4) {
          title = '填写汇报';
        }
      }
      return title;
    },
    title01: function title01() {
      var title = '';
      if (!this.editId) {
        if (this.dailyId === 1) {
          title = this.$t('user.work.todaywork');
        } else if (this.dailyId === 2) {
          title = this.$t('user.work.weekwork');
        } else if (this.dailyId === 3) {
          title = this.$t('user.work.monthwork');
        } else if (this.dailyId === 4) {
          title = '填写汇报';
          this.report_show = true;
        }
      } else {
        if (this.types === 0) {
          title = this.$t('user.work.todaywork');
        } else if (this.types === 1) {
          title = this.$t('user.work.weekwork');
        } else if (this.types === 2) {
          title = this.$t('user.work.monthwork');
        } else if (this.dailyId === 3) {
          title = '填写汇报';
        }
      }
      return title;
    },
    title02: function title02() {
      var title = '';
      if (!this.editId) {
        if (this.dailyId === 1) {
          title = '下个工作日计划';
        } else if (this.dailyId === 2) {
          title = this.$t('user.work.nextweekplan');
        } else if (this.dailyId === 3) {
          title = this.$t('user.work.nextmonthplan');
        } else if (this.dailyId === 4) {
          title = '填写汇报';
        }
      } else {
        if (this.types === 0) {
          title = '下个工作日计划';
        } else if (this.types === 1) {
          title = this.$t('user.work.nextweekplan');
        } else if (this.types === 2) {
          title = this.$t('user.work.nextmonthplan');
        } else if (this.dailyId === 3) {
          title = '填写汇报';
        }
      }
      return title;
    }
  },
  mounted: function mounted() {
    this.getCompletedFn();
    this.approveApplyList();
    this.rollHeight = "".concat(document.documentElement.clientHeight) - 66 - 50;
    var that = this;
    window.onresize = function () {
      that.rollHeight = "".concat(document.documentElement.clientHeight) - 66 - 50;
    };
  },
  methods: {
    scheduleStatus: function scheduleStatus() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return scheduleStatusApi();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateValue: function updateValue() {
      this.$emit('updateValue', this.ruleForm.finish);
    },
    // 点击完成待办
    setScheduleRecord: function setScheduleRecord(item, status, index) {
      var _this2 = this;
      this.checkedList = '';
      this.checkedList = item.title;
      var info = {
        status: status,
        start: item.start_time,
        end: item.end_time
      };
      scheduleStatusApi(item.id, info);
      item.checked = true;
      setTimeout(function () {
        _this2.$emit('getDailyTodoInfo');
      }, 500);
    },
    // 获取人员配置表单
    approveApplyList: function approveApplyList(id, data) {
      var _this3 = this;
      dailyReportMemberApi(id, data).then(function (res) {
        if (!_this3.editId) {
          _this3.examineData = [];
          res.data.map(function (item) {
            var obj = {
              value: item.card.id,
              name: item.card.name,
              avatar: item.card.avatar
            };
            _this3.examineData.push(obj);
          });
        }
      });
    },
    getCompletedFn: function getCompletedFn() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var type, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              type = _this4.dailyId - 1;
              _context2.next = 3;
              return getCompleted(type);
            case 3:
              result = _context2.sent;
              _this4.ruleForm.finish = result.data.finish.map(function (item) {
                return item + '\n';
              }).join('');
              _this4.ruleForm.plan = result.data.plan.map(function (item) {
                return item + '\n';
              }).join('');
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getInfo: function getInfo(editId, type, data) {
      var _this5 = this;
      if (data && data.types == 3) {
        this.report_show = true;
      } else {
        this.report_show = false;
      }
      this.editType = type;
      getEnterpriseEdit(editId).then(function (res) {
        var data = res.data;
        _this5.newTitle = data.card.name + '的汇报';
        _this5.ids = [];
        _this5.reply.daily_id = editId;
        _this5.drawer = true;
        _this5.ruleForm.finish = data.finish.map(function (item) {
          return item + '\n';
        }).join('');
        _this5.ruleForm.plan = data.plan.map(function (item) {
          return item + '\n';
        }).join('');
        _this5.ruleForm.mark = data.mark;
        _this5.types = data.types;
        _this5.replyList = data.replys;
        _this5.attachList = data.attachs;
        if (_this5.editId) {
          _this5.examineData = [];
          data.members.map(function (item) {
            var obj = {
              value: item.card.id,
              name: item.card.name,
              avatar: item.card.avatar
            };
            _this5.examineData.push(obj);
          });
        }
      });
    },
    submitReply: function submitReply() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.reply.pid = _this6.id;
              _context3.next = 3;
              return dailyReply(_this6.reply);
            case 3:
              _context3.next = 5;
              return _this6.getInfo(_this6.editId, true, _this6.editData);
            case 5:
              _this6.isShow = false;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changeSize: function changeSize() {
      var fH = this.$refs.finish.$el.clientHeight;
      var pH = this.$refs.plan.$el.clientHeight;
      if (fH > this.minHeight || pH > this.minHeight) {
        if (fH > pH) {
          this.$refs.plan.$el.firstChild.style.height = fH + 'px';
          this.$refs.finish.$el.firstChild.style.height = fH + 'px';
        }
        if (fH < pH) {
          this.$refs.finish.$el.firstChild.style.height = pH + 'px';
          this.$refs.plan.$el.firstChild.style.height = pH + 'px';
        }
      }
    },
    deleteReply: function deleteReply(id, dailyId, index) {
      var _this7 = this;
      this.$modalSure(this.$t('user.work.title4')).then(function () {
        dailydel(id, dailyId).then(function (res) {
          _this7.replyList.splice(index, 1);
        });
      });
    },
    replyBnt: function replyBnt(item) {
      var _this8 = this;
      this.textPla = this.$t('public.reply') + ': ' + "".concat(item.card.name);
      this.reply.content = '';
      this.id = item.id;
      this.isShow = true;
      this.$nextTick(function () {
        _this8.$refs.rollBottom.scroll(0, _this8.rollHeight);
      });
    },
    evaluate: function evaluate() {
      var _this9 = this;
      this.reply.content = '';
      this.id = 0;
      this.isShow = true;
      this.textPla = this.$t('user.work.writecomment');
      this.$nextTick(function () {
        _this9.$refs.rollBottom.scroll(0, _this9.rollHeight);
      });
      setTimeout(function () {
        _this9.$refs.replyInput.focus();
      }, 300);
    },
    cancel: function cancel() {
      this.isShow = false;
      this.report_show = false;
      this.textPla = this.$t('user.work.writedaily');
    },
    handleClose: function handleClose() {
      this.resetForm();
      this.drawer = false;
      this.report_show = false;
      this.$refs.ruleForm.clearValidate();
    },
    closeBtn: function closeBtn() {
      this.resetForm();
      this.$refs.ruleForm.clearValidate();
      if (this.editId) {
        this.drawer = false;
      }
      if (this.editId && this.disabled) {
        this.$emit('tableList');
      }
      this.report_show = false;
      this.drawer = false;
    },
    handleExamineDataUpdate: function handleExamineDataUpdate(newData) {
      this.examineData = newData;
    },
    submitForm: function submitForm(formName) {
      var _this10 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this10.editId <= 0) {
            _this10.ruleForm.types = _this10.dailyId - 1;
          } else {
            _this10.ruleForm.types = _this10.types;
          }
          var processInfo = _this10.examineData;
          processInfo.forEach(function (value, index) {
            if (value.length <= 0) {
              processInfo.splice(index, 1);
            }
          });
          var ids = [];
          _this10.attachList.map(function (item) {
            ids.push(item.id);
          });
          _this10.ruleForm.attach_ids = ids.join(',');
          var members = [];
          if (processInfo.length == 0) {
            _this10.$message.error('请选择汇报人');
            return;
          }
          if (processInfo.length > 0) {
            processInfo.forEach(function (item) {
              members.push(item.value);
            });
          }
          var data = {
            finish: _this10.ruleForm.finish.split('\n').filter(function (item) {
              return item.trim() !== '';
            }),
            plan: _this10.ruleForm.plan.split('\n').filter(function (item) {
              return item.trim() !== '';
            }),
            members: members,
            types: _this10.ruleForm.types,
            mark: _this10.ruleForm.mark,
            attach_ids: _this10.ruleForm.attach_ids
          };
          if (_this10.report_show) {
            data.plan = [];
          }
          _this10.saveLoading = true;
          var head = _this10.editId ? getDailyEdit(data, _this10.editId) : enterpriseDaily(data);
          head.then(function (res) {
            _this10.$emit('tableList');
            _this10.resetForm();
            _this10.drawer = false;
            _this10.saveLoading = false;
          }).catch(function (err) {
            _this10.resetForm();
            _this10.drawer = false;
            _this10.saveLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm() {
      this.isShow = false;
      this.textPla = this.$t('user.work.writedaily');
      this.ruleForm = {
        finish: '',
        plan: '',
        mark: '',
        attach_ids: []
      };
      this.attachList = [];
      this.$refs.ruleForm.resetFields();
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      this.attachList.push(response);
    },
    // 添加参与人
    handlesuperiorOpen: function handlesuperiorOpen() {
      this.$refs.selectMember.handlePopoverShow();
    },
    // 删除参与人
    userDelete: function userDelete(val) {
      this.examineData = this.examineData.filter(function (item) {
        return item.value != val.value;
      });
    },
    // 获取部门回调
    getSelectList: function getSelectList(data) {
      this.examineData = data;
    }
  }
};